























































































import { Component, Watch } from 'vue-property-decorator';
import Base from '@/views/Base';
import HeaderLayout from '@/layouts/nested/HeaderLayout.vue';
import WListOptions from '@/components/listlayout/WListOptions.vue';
import { WaitingRoomBranding } from '@/models/WaitingRoomBranding';
import WaitingRoomBrandingService from '@/service/WaitingRoomBrandingService';
import { round } from 'lodash';
import ElementPlayerModal from '@/views/presentation/components/ElementPlayerModal.vue';
import WaitingRoomPreview from '@/views/presentation/waitingRoomBranding/WaitingRoomPreview.vue';

@Component({
  methods: { round },
  components: { WaitingRoomPreview, ElementPlayerModal, WListOptions, HeaderLayout }
})
export default class WaitingRoomBrandingIndex extends Base {

  brandings: WaitingRoomBranding[] = [];

  currentSelectOption = '';

  options = {
    searchTerm: '',
    sortBy: 'dateCreated',
    sortDirection: 'DESC'
  };

  @Watch('options', { deep: true })
  onOptionsChange() {
    this.brandings = this.sortBrandings(this.brandings);
  }

  sortBrandings(brands: WaitingRoomBranding[]) {
    return brands.sort((a, b) => {
      if (this.options.sortBy === 'title') {
        return this.options.sortDirection === 'ASC' ? a.title.localeCompare(b.title) : b.title.localeCompare(a.title);
      } else if (this.options.sortBy === 'dateCreated') {
        const dateA = new Date(a.dateCreated).getTime();
        const dateB = new Date(b.dateCreated).getTime();
        return this.options.sortDirection === 'ASC' ? dateA - dateB : dateB - dateA;
      } else if (this.options.sortBy === 'dateUpdated') {
        const dateA = new Date(a.dateUpdated).getTime();
        const dateB = new Date(b.dateUpdated).getTime();
        return this.options.sortDirection === 'ASC' ? dateA - dateB : dateB - dateA;
      }
      return 0;
    });
  }

  selectedBrandings: number[] = [];

  mounted() {
    this.loadBrandings();
  }

  @Watch('options.searchTerm')
  searchUpdated() {
    this.loadBrandings();
  }

  sort() {
    this.loadBrandings();
  }

  async loadBrandings() {
    WaitingRoomBrandingService.getWaitingRoomBrandings().then(res => {
      this.brandings = this.sortBrandings(res);
    }).catch(this.showNetworkError);
  }

  async updateBranding(branding: WaitingRoomBranding) {
    if(branding.global && !this.hasPermission('CUSTOMER_PRESENTATION')) return
    await this.$router.push('/presentation/waitingroom/' + branding.id);
  }

  async createNewBranding() {
    const branding = await WaitingRoomBrandingService.createWaitingRoom(WaitingRoomBrandingService.getEmptyWaitingRoom());
    await this.$router.push('/presentation/waitingroom/' + branding.id);
  }

  async deleteBranding(branding: WaitingRoomBranding) {
    this.$bvModal.msgBoxConfirm(this.$t('modals.deleteWaitingRoomBranding.descriptionSingle', { name: branding.title }) as string, {
      title: this.t('modals.deleteWaitingRoomBranding.title'),
      size: 'md',
      okVariant: 'danger',
      okTitle: this.t('modals.deleteWaitingRoomBranding.okSingle'),
      cancelTitle: this.t('common.cancel'),
      centered: true
    })
      .then(value => {
        if (value) {
          WaitingRoomBrandingService.deleteWaitingRoom(branding.id).then(() => {
            this.loadBrandings();
          }).catch(this.showNetworkError);
        }
      });
  }

  deleteSelected() {
    this.$bvModal.msgBoxConfirm(this.t('modals.deleteWaitingRoomBranding.description'), {
      title: this.t('modals.deleteWaitingRoomBranding.title'),
      size: 'md',
      okVariant: 'danger',
      okTitle: this.t('modals.deleteWaitingRoomBranding.ok'),
      cancelTitle: this.t('common.cancel'),
      centered: true
    })
      .then(value => {
        if (value) {
          this.selectedBrandings.forEach(id => {
            WaitingRoomBrandingService.deleteWaitingRoom(id).then(() => {
              this.loadBrandings();
            }).catch(this.showNetworkError);
          });
        }
      });
  }

  openPreviewModal(branding: WaitingRoomBranding) {
    const preview = this.$refs['wr-preview'] as any;
    preview.showPreview(branding);
  }

  formatDuration(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

}
